// Empire Apps Chassis · identity-zkp · barrel
//
// Privacy-preserving identity layer for the empire. Lets a user prove things
// like "I am over 18", "I am a nominee for this asset class", "my ABHA is
// active" without revealing the underlying PII.
//
// Quick reference:
//   - did.ts                 DID generation, multibase, Ed25519 signing
//   - did-resolver.ts        did:key (local) + did:web (fetch+cache)
//   - commitment.ts          HMAC-SHA256 hiding/binding commitments
//   - bbs-plus.ts            BBS+ adapter (hash-commitment fallback for v0)
//   - selective-disclosure.ts predicate engine: eq, gte, lte, in, reveal, range
//   - vc.ts                  W3C VC v2.0 issue + verify
//   - presentation.ts        VP builder + verifier + verifier challenges
//   - aadhaar-zkp.ts         Aadhaar predicates (age_gte_18, indian_resident, etc)
//   - pan-zkp.ts             PAN predicates (holder_type, structural_valid)
//   - abha-zkp.ts            ABHA predicates (active, age_band, gender)
//   - nominee-zkp.ts         Wasiyat nominee bindings
//   - consent-bundle.ts      DPDP 2023 consent receipts as VCs

export * from './types.ts';
export * from './did.ts';
export * from './did-resolver.ts';
export * from './commitment.ts';
export * from './bbs-plus.ts';
export * from './selective-disclosure.ts';
export * from './vc.ts';
export * from './presentation.ts';
export * from './aadhaar-zkp.ts';
export * from './pan-zkp.ts';
export * from './abha-zkp.ts';
export * from './nominee-zkp.ts';
export * from './consent-bundle.ts';
